<template>
    <div class="content" v-cloak>
        <!-- 첫페이지 모달  preTestGate.vue -->
        <aw-pre-test-gate 
            v-on:skip="skip"
        ></aw-pre-test-gate>
        <h2 class="content_title">사전 역량 체크리스트</h2>
        <div class="content_wrap">
            
            <!-- 바디 -->
            <aw-pre-test-body 
                v-for="checkList in this.contents.currentSlide.checkList" :key="checkList.page"
                :checkList="checkList"
                :currentTestPage.sync = currentTestPage
                v-on:goNext="goNext"
                v-on:goPrevious="goPrevious"
                v-on:answered="answered"
            ></aw-pre-test-body>

            <aw-pre-test-result
                v-if="resultFlag"
                :currentSlide="contents.currentSlide"
                :answered="result"
                v-on:skip="skip"
            ></aw-pre-test-result>

            <audio v-if="this.contents.currentSlide.bgm != undefined" ref="preTestAudio">
                <source :src="'../assets/media/' + this.contents.currentSlide.bgm" type="audio/mpeg">
            </audio>

        </div>
    </div> 
</template>
<script>
export default {
    props : ['contents'],
    data(){
        return{
            currentTestPage : 1,
            resultFlag : false,
            result : _.map(new Array(this.contents.currentSlide.checkList.length),{
                result : false
            }),
        }
    },
    methods:{
        closeModal(){
            this.$modal.hide('preTestGate');
        },
        skip(){
            location.href =  "./" + pad(this.contents.slideNumber + 1) + ".html";
        },
        goNext(page){
            console.log('preTest goNext called');
            if(this.contents.currentSlide.checkList.length == page){//result page
                this.currentTestPage = page + 1;
                this.resultFlag = true
            }else if(this.contents.currentSlide.checkList.length < page){//next page
                this.skip();
            }else{
                this.currentTestPage = page + 1;
            }
        },
        goPrevious(page){
            if(page > 1){
                this.currentTestPage = page - 1;
            }
        },
        answered(order,answer){//from children
            this.result[order - 1] = answer;//store result
        },
    },
    mounted(){
        console.log('mounted');
        this.$modal.show("preTestGate");
        setTimeout(()=>{
            this.$refs.preTestAudio.play()
        }, 1000);
    }
}
</script>